import { FULL_HD, HD, IMAGE_FIT_MAX, RENDERING_CONTEXT } from '@bedrock-rdk/constants';

export const templates = {
  Banner: 'Banner',
};

export const sizes = {
  [templates.Banner]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        w: 1024,
        h: 341,
      },
      [FULL_HD]: {
        w: 1560,
        h: 520,
      },
    },
    [RENDERING_CONTEXT.SEARCH]: {
      [HD]: {
        w: 674,
        h: 224,
      },
      [FULL_HD]: {
        w: 1024,
        h: 342,
      },
    },
  },
};

export const imageOptions = {
  [templates.Banner]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        PRIMARY: {
          width: 1024,
          height: 341,
        },
        LOGO: {
          width: 123,
          height: 69,
          fit: IMAGE_FIT_MAX,
        },
      },
      [FULL_HD]: {
        PRIMARY: {
          width: 1560,
          height: 520,
        },
        LOGO: {
          width: 176,
          height: 99,
          fit: IMAGE_FIT_MAX,
        },
      },
    },
  },
};
